import PropTypes from 'prop-types';
import React from 'react';
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';
import { filterRunsByStatus, sortByClothNo } from 'modules/GreyhoundRacing/utils/runFilter';
import { metaDescription } from 'utils/seoUtils';

import GreyhoundRacingRacecardRunner from './GreyhoundRacingRacecardRunner';
import GreyhoundRacingRacecardNonRunners from './GreyhoundRacingRacecardNonRunners';

export default function GreyhoundRacingRacecardPreRace(props) {

  const {
    runs : raceRuns,
    race_summary : raceSummary
  } = props.race;

  const transformData = (runners) => {
    const hn = hideNull;
    return (runners.map(runner => ({
      key : runner.run_reference.id,
      clothNo: hn(runner.cloth_number),
      drawNumber: bracket(runner.draw_number),
      position : `${hn(runner.finish_position)} ${bracket(runner.draw_number)}`,
      form : hn(runner.greyhound.formsummary.display_text),
      bestRunTime: runner.best_run_time,
      lastRunTime: runner.greyhound.previous_results.length > 0 ? runner.greyhound.previous_results[0].run_time : undefined,
      commentary: hn(runner.commentary),
      formWatch: hn(runner.formwatch),
      greyhound : runner.greyhound,
      greyhoundName : hn(runner.greyhound.name),
      greyhoundLastRan:  hn(runner.greyhound.last_ran_days),
      greyhoundAge : hn(runner.greyhound.age),
      weight : hn(runner.handicap),
      rideBetlinkIds: hn(runner.run_reference.external_reference.filter(r => r.ref === 'skybet').map(r => r.value)),
      trainer : runner.trainer,
      owner : runner.owner,
      odds : hn(runner.betting.current_odds),
      reserve : runner.reserve
    })))
  }

  const sortedRaceRuns = [...raceRuns].sort(sortByClothNo);
  const runners = transformData(filterRunsByStatus(sortedRaceRuns, "RUNNER"));
  const nonRunners = transformData(filterRunsByStatus(sortedRaceRuns, "NONRUNNER"));


  const names = [];
  sortedRaceRuns.forEach(({ greyhound: {name = ''} = {}}) => names.push(" " + name));


  const metaDescriptionValue = `View the racecard and form for dogs:${names}`;

  return (
    <section>
      <MetaDataWrapper helmetProps={{...metaDescription(metaDescriptionValue)}} />
      {
        runners.map(runner => {
          return <GreyhoundRacingRacecardRunner
            runner={runner}
            key={runner.key}
          />
        })
      }
      <GreyhoundRacingRacecardNonRunners nonRunners={nonRunners}/>
    </section>
  );
}

GreyhoundRacingRacecardPreRace.propTypes = {
  race : PropTypes.object.isRequired,
  meeting: PropTypes.object,
  meetings: PropTypes.object
};

function hideNull(element) {
  return element ? element : '';
}

function bracket(element) {
  return element ? `(${element})` : '';
}



// WEBPACK FOOTER //
// ./modules/GreyhoundRacing/components/GreyhoundRacingRacecardPreRace.js